import BaseLevelScene from './BaseLevelScene';

export default class CastleScene extends BaseLevelScene {
  tileWidth: integer = 32;
  tileHeight: integer = 32;
  name: string;
  tileMapName: string;
  tileMapPath: string;
  constructor(name: string, tilemapName:string, tileMapPath: string) {
    super(name);
    this.name = name;
    this.tileMapName = tilemapName;
    this.tileMapPath = tileMapPath;
  }

  preload() {

    // Preload base level
    this.preloadBaseLevel();

    // load the PNG files
    this.load.image('beds_tiles', 'assets/sourceImages/beds48x32.png');
    this.load.image('carpets_tiles', 'assets/sourceImages/carpets32x32.png');
    this.load.image('castle_interiors_tiles', 'assets/sourceImages/castle_interriors.png');
    this.load.image('clocks_tiles', 'assets/sourceImages/clocks16x48.png');
    this.load.image('decorations_tiles', 'assets/sourceImages/castle_decoratives.png');
    this.load.image('fireplace_tiles', 'assets/sourceImages/fireplace.png');
    this.load.image('light1a_tiles', 'assets/items/light1a.png');
    this.load.image('light2a_tiles', 'assets/items/light2a.png');

    // load the JSON map
    this.load.tilemapTiledJSON(
      this.tileMapName,
      this.tileMapPath
    );
  }

  create() {
    // 👌 sanity check by displaying the entire tileset image (all checked out)
    // this.add.image(0, 0, 'light1a_tiles');

    // create the Tilemap
    this.map = this.make.tilemap({ key: this.tileMapName });

    // add the tileset image we are using (note name must match tileset in map)
    
    const bedsTileset = this.map.addTilesetImage('beds48x32', 'beds_tiles');
    const carpetsTileset = this.map.addTilesetImage('carpets', 'carpets_tiles');
    const interiorTileset = this.map.addTilesetImage('castle_interiors', 'castle_interiors_tiles');
    const clocksTileset = this.map.addTilesetImage('clocks', 'clocks_tiles');
    const decorationsTileset = this.map.addTilesetImage('castle_decorations', 'decorations_tiles');
    const fireplaceTileset = this.map.addTilesetImage('fireplace', 'fireplace_tiles');
    const light1aTileset = this.map.addTilesetImage('light1a', 'light1a_tiles');
    const light2aTileset = this.map.addTilesetImage('light2a', 'light2a_tiles');

    const allLayers = [bedsTileset, carpetsTileset, interiorTileset, clocksTileset, decorationsTileset, fireplaceTileset, light1aTileset, light2aTileset];

    // // create the layers we want in the right order
    const base = this.map.createLayer('Base', allLayers);
    this.map.setCollisionByProperty({collides: true});
    this.matter.world.convertTilemapLayer(base);

    const textures = this.map.createLayer('Textures', allLayers);
    // this.map.setCollisionByProperty({collides: true});
    this.matter.world.convertTilemapLayer(textures);

    const furniture = this.map.createLayer('Furniture', allLayers);
    this.map.setCollisionByProperty({collides: true});
    this.matter.world.convertTilemapLayer(furniture);

    const decorations = this.map.createLayer('Decorations', allLayers);
    // this.map.setCollisionByProperty({collides: true});
    this.matter.world.convertTilemapLayer(decorations);

    // create base level
    this.createBaseLevel(0.75, 2);

    // Add an overlay layer on top of items to hide them
    try {
      this.createOverlayLayer(this.map, interiorTileset, this.hitOverlay);
    } catch (error) {
      console.warn("No Overlay layer found in map.");
    }
  }
}
